// Script for versus page

import '../jquery-ui';

import * as versus from './includes/versus';
versus.autocomplete();